import { PerfectMoneyService } from "@/services";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
export default {
  name: "perfect-money",
  components: {},
  props: [],
  data() {
    return {
      perfectMoneyList: [],
      isVerified: true
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: types.userInfo.getters.GET_USER_INFO
    }),
    isVerify() {
      if (Object.entries(this.getUserInfo).length !== 0) {
        return this.getUserInfo.is_verified;
      }
    }
  },
  mounted() {
    this.getFiatList();
    // this.getUserInformation();
  },
  methods: {
    getFiatList() {
      PerfectMoneyService.getFiats().then(response => {
        this.perfectMoneyList = response.data.data;
      });
    },
    changeUrl(from, type) {
      this.$router.push({
        path: "/operation-fiat/" + type,
        query: { from: from }
      });
    }
    // getUserInformation() {
    //   AuthService.userInfo().then(response => {
    //     this.isVerified = response.data.data.is_verified;
    //   });
    // }
  }
};
